<template>
    <div class="launch-btn">
        <template v-if="isWeixin">
            <wx-open-launch-app id="launch-btn" appid="wx06e2261b67e781d0" @error="onError">
                <script type="text/wxtag-template">
                    <style>.btn { outline: none;border: none;font-weight: 700;font-size: 17px;color: #06ae56;background-color: #f2f2f2;width: 184px;padding: 8px 24px;line-height: 1.41176471;border-radius: 4px; }</style>
                                            <button class="btn">{{label}}</button>
                                          </script>
            </wx-open-launch-app>
        </template>
        <template v-else>
            <a @click="openUrl()" class="weui-btn weui-btn_default" style="width:auto">{{
                label
            }}</a>
        </template>
    </div>
</template>
  
<script>
import weixin from "@/mixins/weixin";

export default {
    mixins: [weixin],
    props: {
        label: {
            type: String,
            default: "打开华商云服APP",
        },
        url: {
            type: String,
            default: "usoftchinasaas://",
        },
        appid: {
            type: String,
            default: "__UNI__4357935",
        }
    },
    data() {
        return {
            isWeixin: this.isWeixinClient() && !this.isWxWorkClient()
        };
    },
    mounted() {
        if (!this.isWeixin) {
            // 自动打开
            window.location.href = this.url;
        }
    },
    methods: {
        onError(e) {
            this.$weui.topTips(e.detail, 3000);
        },
        openUrl() {
            this.fallbackOpenAppPortal();
            let userAgent = navigator.userAgent, url = this.url;
            if (userAgent.match(/(iPhone|iPod|iPad);?/i)) {
                let iOS = userAgent.match(/(iPhone\sOS)\s([\d]+)/) || userAgent.match(/(iPad).*OS\s([\d_]+)/) || userAgent.match(/(iPod)(.*OS\s([\d_]+))?/);
                let iOS9 = parseInt(iOS[2], 10);
                if (iOS9 >= 9) {
                    window.location.href = url;
                } else {
                    this.openLink(url);
                }
            } else if (navigator.userAgent.match(/android/i)) {
                this.openLink(url);
            } else {
                window.location.href = url;
            }
        },
        openLink(url) {
            let a = document.createElement('a');
            a.setAttribute('href', url);
            a.click();
        },
        fallbackOpenAppPortal() {
            const me = this;
            const toast = me.$weui.loading('加载中');
            setTimeout(function () {
                let counter = 0;
                const checkOpen = setInterval(() => {
                    if (counter++ > 50) {
                        clearInterval(checkOpen);
                        toast.hide();
                        me.openAppPortal();
                        return;
                    }
                    const hide = document.hidden || document.webkitHidden;
                    if (hide) {
                        clearInterval(checkOpen);
                        toast.hide();
                    }
                }, 20);
            }, 1000);
        },
        openAppPortal() {
            this.$router.push({
                name: 'AppPortal',
                query: {
                    appid: this.appid,
                    redirect: true
                }
            });
        }
    },
};
</script>
  
<style scoped>
.launch-btn {
    margin: 20px 40px;
    text-align: center;
}
</style>